module.exports = __webpack_public_path__ + "static/media/country_im.65240390.webp";